import React from 'react';
import { useSelector } from 'react-redux';
import { canWrite } from '../../../../../../common/permissions/permissionUtil';
import { ActionMenu } from '@milanote/roma/application';
import { FilePicker, Popover } from '@milanote/roma';
import { Button } from 'react-aria-components';

import Icon from '../../../../../components/icons/Icon';
import { selectIsTabletFormFactor } from '../../../../../platform/platformSelector';
import ElementContextMenu from '../../../../contextMenu/ElementContextMenu';
import {
    elementDesktopToolbarMenuConfig,
    elementTabletToolbarMenuConfig,
} from '../../../../contextMenu/configs/elementContextMenuConfig';
import useToolbarPopover from '../../../hooks/useToolbarPopover';
import ToolbarTool from '../../ToolbarTool';

// TODO WEB-16910: Share More tool styling without relying on legacy popup class names.
import '../../moreTool/MoreTool.scss';

export const DESKTOP_ELEMENT_CONTEXT_MENU_TOOL_ID = 'DESKTOP_CONTEXT_MENU';

type DesktopElementContextMenuToolProps = {
    name?: string;
    permissions: number;
};

/**
 * Opens the shared element menu from the selected-element toolbar.
 * TODO WEB-16910: Consolidate the shared More tool shell with TableContextMenuTool.
 */
const DesktopElementContextMenuTool: React.FC<DesktopElementContextMenuToolProps> = ({
    name = 'More',
    permissions,
    ...toolProps
}) => {
    const isTablet = useSelector(selectIsTabletFormFactor);
    const { isOpen, onOpenChange } = useToolbarPopover();
    const menuConfig = isTablet ? elementTabletToolbarMenuConfig : elementDesktopToolbarMenuConfig;
    const isEditable = canWrite(permissions);
    const menuIsOpen = isEditable && isOpen;

    return (
        <FilePicker.Provider>
            <div className="MoreTool ToolbarPopupTool">
                <Popover.MenuTrigger
                    isOpen={menuIsOpen}
                    onOpenChange={(nextIsOpen) => isEditable && onOpenChange(nextIsOpen)}
                >
                    <Button className="Button" aria-label={name} isDisabled={!isEditable}>
                        <ToolbarTool {...toolProps} isOpen={menuIsOpen} tooltipEnabled={!menuIsOpen}>
                            <Icon name="toolbar-more" />
                        </ToolbarTool>
                    </Button>
                    <Popover className={ActionMenu.styles.width} placement="end top" offset={4} crossOffset={6}>
                        <ElementContextMenu isEditable={isEditable} menuConfig={menuConfig} size="sm" />
                    </Popover>
                </Popover.MenuTrigger>
            </div>
        </FilePicker.Provider>
    );
};

export default DesktopElementContextMenuTool;
